export const TURKEY_CITIES = [
  {
    il: 'Adana',
    ilceler: ['Aladağ','Ceyhan','Çukurova','Feke','İmamoğlu','Karaisalı','Karataş','Kozan','Pozantı','Saimbeyli','Sarıçam','Seyhan','Tufanbeyli','Yumurtalık','Yüreğir'],
  },
  {
    il: 'Adıyaman',
    ilceler: ['Adıyaman','Besni','Çelikhan','Gerger','Gölbaşı','Kahta','Samsat','Sincik','Tut'],
  },
  {
    il: 'Afyonkarahisar',
    ilceler: ['Afyonkarahisar','Başmakçı','Bayat','Bolvadin','Çay','Çobanlar','Dazkırı','Dinar','Emirdağ','Evciler','Hocalar','İhsaniye','İscehisar','Kızılören','Sandıklı','Sinanpaşa','Sultandağı','Şuhut'],
  },
  {
    il: 'Ağrı',
    ilceler: ['Ağrı','Diyadin','Doğubayazıt','Eleşkirt','Hamur','Patnos','Taşlıçay','Tutak'],
  },
  {
    il: 'Aksaray',
    ilceler: ['Ağaçören','Aksaray','Eskil','Gülağaç','Güzelyurt','Ortaköy','Sarıyahşi','Sultanhanı'],
  },
  {
    il: 'Amasya',
    ilceler: ['Amasya','Göynücek','Gümüşhacıköy','Hamamözü','Merzifon','Suluova','Taşova'],
  },
  {
    il: 'Ankara',
    ilceler: ['Altındağ','Ayaş','Bala','Beypazarı','Çamlıdere','Çankaya','Çubuk','Elmadağ','Etimesgut','Evren','Gölbaşı','Güdül','Haymana','Kalecik','Kazan','Keçiören','Kızılcahamam','Mamak','Nallıhan','Polatlı','Pursaklar','Sincan','Şereflikoçhisar','Yenimahalle'],
  },
  {
    il: 'Antalya',
    ilceler: ['Akseki','Aksu','Alanya','Demre','Döşemealtı','Elmalı','Finike','Gazipaşa','Gündoğmuş','İbradı','Kale','Kaş','Kemer','Kepez','Konyaaltı','Korkuteli','Kumluca','Manavgat','Muratpaşa','Serik'],
  },
  {
    il: 'Ardahan',
    ilceler: ['Ardahan','Çıldır','Damal','Göle','Hanak','Posof'],
  },
  {
    il: 'Artvin',
    ilceler: ['Ardanuç','Arhavi','Artvin','Borçka','Hopa','Kemalpaşa','Murgul','Şavşat','Yusufeli'],
  },
  {
    il: 'Aydın',
    ilceler: ['Bozdoğan','Buharkent','Çine','Didim','Efeler','Germencik','İncirliova','Karacasu','Karpuzlu','Koçarlı','Köşk','Kuşadası','Kuyucak','Nazilli','Söke','Sultanhisar','Yenipazar'],
  },
  {
    il: 'Balıkesir',
    ilceler: ['Altıeylül','Ayvalık','Balya','Bandırma','Bigadiç','Burhaniye','Dursunbey','Edremit','Erdek','Gömeç','Gönen','Havran','İvrindi','Karesi','Kepsut','Manyas','Marmara','Savaştepe','Sındırgı','Susurluk'],
  },
  {
    il: 'Bartın',
    ilceler: ['Amasra','Bartın','Kurucaşile','Ulus'],
  },
  {
    il: 'Batman',
    ilceler: ['Batman','Beşiri','Gercüş','Hasankeyf','Kozluk','Sason'],
  },
  {
    il: 'Bayburt',
    ilceler: ['Aydıntepe','Bayburt','Demirözü'],
  },
  {
    il: 'Bilecik',
    ilceler: ['Bilecik','Bozüyük','Gölpazarı','İnhisar','Osmaneli','Pazaryeri','Söğüt','Yenipazar'],
  },
  {
    il: 'Bingöl',
    ilceler: ['Adaklı','Bingöl','Genç','Karlıova','Kiğı','Solhan','Yayladere','Yedisu'],
  },
  {
    il: 'Bitlis',
    ilceler: ['Adilcevaz','Ahlat','Bitlis','Güroymak','Hizan','Mutki','Tatvan'],
  },
  {
    il: 'Bolu',
    ilceler: ['Bolu','Dörtdivan','Gerede','Göynük','Kıbrıscık','Mengen','Mudurnu','Seben','Yeniçağa'],
  },
  {
    il: 'Burdur',
    ilceler: ['Ağlasun','Altınyayla','Bucak','Burdur','Çavdır','Çeltikçi','Gölhisar','Karamanlı','Kemer','Tefenni','Yeşilova'],
  },
  {
    il: 'Bursa',
    ilceler: ['Büyükorhan','Gemlik','Gürsu','Harmancık','İnegöl','İznik','Karacabey','Keles','Kestel','Mudanya','Mustafakemalpaşa','Nilüfer','Orhaneli','Orhangazi','Osmangazi','Yenişehir','Yıldırım'],
  },
  {
    il: 'Çanakkale',
    ilceler: ['Ayvacık','Bayramiç','Biga','Bozcaada','Çan','Çanakkale','Eceabat','Ezine','Gelibolu','Gökçeada','Lapseki','Yenice'],
  },
  {
    il: 'Çankırı',
    ilceler: ['Atkaracalar','Bayramören','Çankırı','Eldivan','Ilgaz','Kızılırmak','Korgun','Kurşunlu','Orta','Şabanözü','Yapraklı'],
  },
  {
    il: 'Çorum',
    ilceler: ['Alaca','Bayat','Boğazkale','Dodurga','İskilip','Kargı','Laçin','Mecitözü','Oğuzlar','Ortaköy','Osmancık','Sungurlu','Uğurludağ','Çorum'],
  },
  {
    il: 'Denizli',
    ilceler: ['Acıpayam','Babadağ','Baklan','Bekilli','Beyağaç','Bozkurt','Buldan','Çal','Çameli','Çardak','Çivril','Güney','Honaz','Kale','Merkezefendi','Pamukkale','Sarayköy','Serinhisar','Tavas'],
  },
  {
    il: 'Diyarbakır',
    ilceler: ['Bağlar','Bismil','Çermik','Çınar','Çüngüş','Dicle','Eğil','Ergani','Hani','Hazro','Kayapınar','Kocaköy','Kulp','Lice','Silvan','Sur','Yenişehir'],
  },
  {
    il: 'Düzce',
    ilceler: ['Akçakoca','Cumayeri','Çilimli','Düzce','Gölköy','Gölyaka','Gümusova','Kaynaşlı','Yığılca'],
  },
  {
    il: 'Edirne',
    ilceler: ['Edirne','Enez','Havsa','İpsala','Keşan','Lalapaşa','Meriç','Süloğlu','Uzunköprü'],
  },
  {
    il: 'Elazığ',
    ilceler: ['Ağın','Alacakaya','Arıcak','Baskil','Elazığ','Karakoçan','Keban','Kovancılar','Maden','Palu','Sivrice'],
  },
  {
    il: 'Erzincan',
    ilceler: ['Çayırlı','Erzincan','İliç','Kemah','Kemaliye','Otlukbeli','Refahiye','Tercan','Üzümlü'],
  },
  {
    il: 'Erzurum',
    ilceler: ['Aşkale','Aziziye','Çat','Hınıs','Horasan','İspir','Karaçoban','Karayazı','Köprüköy','Narman','Oltu','Olur','Palandöken','Pasinler','Pazaryolu','Şenkaya','Tekman','Tortum','Uzundere','Yakutiye'],
  },
  {
    il: 'Eskişehir',
    ilceler: ['Alpu','Beylikova','Çifteler','Eskişehir','Günyüzü','Han','İnönü','Mahmudiye','Mihalgazi','Mihalıççık','Odunpazarı','Sarıcakaya','Seyitgazi','Sivrihisar','Tepebaşı'],
  },
  {
    il: 'Gaziantep',
    ilceler: ['Araban','İslahiye','Karkamış','Nizip','Nurdağı','Oğuzeli','Şahinbey','Şehitkamil','Yavuzeli'],
  },
  {
    il: 'Giresun',
    ilceler: ['Alucra','Bulancak','Çamoluk','Çanakçı','Dereli','Doğankent','Espiye','Eynesil','Giresun','Görele','Güce','Keşap','Piraziz','Şebinkarahisar','Tirebolu','Yağlıdere'],
  },
  {
    il: 'Gümüşhane',
    ilceler: ['Gümüşhane','Kelkit','Köse','Kürtün','Şiran','Torul'],
  },
  {
    il: 'Hakkari',
    ilceler: ['Çukurca','Derecik','Hakkari','Şemdinli','Yüksekova'],
  },
  {
    il: 'Hatay',
    ilceler: ['Altınözü','Antakya','Arsuz','Belen','Defne','Dörtyol','Erzin','Hassa','İskenderun','Kırıkhan','Kumlu','Payas','Reyhanlı','Samandağ','Yayladağı'],
  },
  {
    il: 'Iğdır',
    ilceler: ['Aralık','Iğdır','Karakoyunlu','Tuzluca'],
  },
  {
    il: 'Isparta',
    ilceler: ['Aksu','Atabey','Eğirdir','Gelendost','Gönen','Keçiborlu','Senirkent','Sütçüler','Şarkikaraağaç','Uluborlu','Yalvaç','Yenişarbademli','Isparta'],
  },
  {
    il: 'İstanbul',
    ilceler: ['Adalar','Arnavutköy','Ataşehir','Avcılar','Bağcılar','Bahçelievler','Bakırköy','Başakşehir','Bayrampaşa','Beşiktaş','Beykoz','Beylikdüzü','Beyoğlu','Büyükçekmece','Çatalca','Çekmeköy','Esenler','Esenyurt','Eyüpsultan','Fatih','Gaziosmanpaşa','Güngören','Kadıköy','Kağıthane','Kartal','Küçükçekmece','Maltepe','Pendik','Sancaktepe','Sarıyer','Silivri','Sultanbeyli','Sultangazi','Şile','Şişli','Tuzla','Ümraniye','Üsküdar','Zeytinburnu'],
  },
  {
    il: 'İzmir',
    ilceler: ['Aliağa','Balçova','Bayındır','Bayraklı','Bergama','Beydağ','Bornova','Buca','Çeşme','Çiğli','Dikili','Foça','Gaziemir','Güzelbahçe','Karabağlar','Karaburun','Karşıyaka','Kemalpaşa','Kınık','Kiraz','Konak','Menderes','Menemen','Narlıdere','Ödemiş','Seferihisar','Selçuk','Tire','Torbalı','Urla'],
  },
  {
    il: 'Kahramanmaraş',
    ilceler: ['Afşin','Andırın','Çağlayancerit','Dulkadiroğlu','Ekinözü','Elbistan','Göksun','Nurhak','Onikişubat','Pazarcık','Türkoğlu'],
  },
  {
    il: 'Karabük',
    ilceler: ['Eflani','Eskipazar','Karabük','Ovacık','Safranbolu','Yenice'],
  },
  {
    il: 'Karaman',
    ilceler: ['Ayrancı','Başyayla','Ermenek','Karaman','Kazımkarabekir','Sarıveliler'],
  },
  {
    il: 'Kars',
    ilceler: ['Arpaçay','Digor','Kağızman','Kars','Sarıkamış','Selim','Susuz'],
  },
  {
    il: 'Kastamonu',
    ilceler: ['Abana','Ağlı','Araç','Azdavay','Bozkurt','Çatalzeytin','Daday','Devrekani','Doğanyurt','Hanönü','İhsangazi','İnebolu','Kastamonu','Küre','Pınarbaşı','Seydiler','Şenpazar','Taşköprü','Tosya'],
  },
  {
    il: 'Kayseri',
    ilceler: ['Akkışla','Bünyan','Develi','Felahiye','Hacılar','İncesu','Kocasinan','Melikgazi','Özvatan','Pınarbaşı','Sarıoğlan','Sarız','Talas','Tomarza','Yahyalı','Yeşilhisar'],
  },
  {
    il: 'Kırıkkale',
    ilceler: ['Bahşili','Balışeyh','Çelebi','Delice','Karakeçili','Keskin','Kırıkkale','Sulakyurt','Yahşihan'],
  },
  {
    il: 'Kırklareli',
    ilceler: ['Babaeski','Demirköy','Kırklareli','Kofçaz','Lüleburgaz','Pehlivanköy','Pınarhisar','Vize'],
  },
  {
    il: 'Kırşehir',
    ilceler: ['Akçakent','Akpınar','Boztepe','Çiçekdağı','Kaman','Kırşehir','Mucur'],
  },
  {
    il: 'Kilis',
    ilceler: ['Elbeyli','Kilis','Musabeyli','Polateli'],
  },
  {
    il: 'Kocaeli',
    ilceler: ['Başiskele','Çayırova','Darıca','Derince','Dilovası','Gebze','Gölcük','İzmit','Kandıra','Karamürsel','Kartepe','Körfez'],
  },
  {
    il: 'Konya',
    ilceler: ['Ahırlı','Akören','Akşehir','Altınekin','Beyşehir','Bozkır','Cihanbeyli','Çeltik','Çumra','Derbent','Derebucak','Doğanhisar','Emirgazi','Ereğli','Güneysinir','Hadim','Halkapınar','Hüyük','Ilgın','Kadınhanı','Karapınar','Karatay','Kulu','Meram','Sarayönü','Selçuklu','Seydişehir','Taşkent','Tuzlukçu','Yalıhüyük','Yunak'],
  },
  {
    il: 'Kütahya',
    ilceler: ['Altıntaş','Aslanapa','Çavdarhisar','Domaniç','Dumlupınar','Emet','Gediz','Hisarcık','Kütahya','Pazarlar','Simav','Şaphane','Tavşanlı'],
  },
  {
    il: 'Malatya',
    ilceler: ['Akçadağ','Arapgir','Arguvan','Battalgazi','Darende','Doğanşehir','Doğanyol','Hekimhan','Kale','Kuluncak','Pütürge','Yazıhan','Yeşilyurt'],
  },
  {
    il: 'Manisa',
    ilceler: ['Ahmetli','Akhisar','Alaşehir','Demirci','Gölmarmara','Gördes','Kırkağaç','Köprübaşı','Kula','Salihli','Sarıgöl','Saruhanlı','Selendi','Soma','Şehzadeler','Turgutlu','Yunusemre'],
  },
  {
    il: 'Mardin',
    ilceler: ['Artuklu','Dargeçit','Derik','Kızıltepe','Mazıdağı','Midyat','Nusaybin','Ömerli','Savur','Yeşilli'],
  },
  {
    il: 'Mersin',
    ilceler: ['Akdeniz','Anamur','Aydıncık','Bozyazı','Çamlıyayla','Erdemli','Gülnar','Mezitli','Mut','Silifke','Tarsus','Toroslar','Yenişehir'],
  },
  {
    il: 'Muğla',
    ilceler: ['Bodrum','Dalaman','Datça','Fethiye','Kavaklıdere','Köyceğiz','Marmaris','Menteşe','Milas','Ortaca','Seydikemer','Ula','Yatağan'],
  },
  {
    il: 'Muş',
    ilceler: ['Bulanık','Hasköy','Korkut','Malazgirt','Muş','Varto'],
  },
  {
    il: 'Nevşehir',
    ilceler: ['Acıgöl','Avanos','Derinkuyu','Gülşehir','Hacıbektaş','Kozaklı','Nevşehir','Ürgüp'],
  },
  {
    il: 'Niğde',
    ilceler: ['Altunhisar','Bor','Çamardı','Çiftlik','Niğde','Ulukışla'],
  },
  {
    il: 'Ordu',
    ilceler: ['Akkuş','Altınordu','Aybastı','Çamaş','Çatalpınar','Çaybaşı','Fatsa','Gölköy','Gülyalı','Gürgentepe','İkizce','Kabadüz','Kabataş','Korgan','Kumru','Mesudiye','Perşembe','Ulubey','Ünye'],
  },
  {
    il: 'Osmaniye',
    ilceler: ['Bahçe','Düziçi','Hasanbeyli','Kadirli','Osmaniye','Sumbas','Toprakkale'],
  },
  {
    il: 'Rize',
    ilceler: ['Ardeşen','Çamlıhemşin','Çayeli','Derepazarı','Fındıklı','Güneysu','Hemşin','İkizdere','İyidere','Kalkandere','Pazar','Rize'],
  },
  {
    il: 'Sakarya',
    ilceler: ['Adapazarı','Akyazı','Arifiye','Erenler','Ferizli','Geyve','Hendek','Karapürçek','Karasu','Kaynarca','Kocaali','Pamukova','Sapanca','Serdivan','Söğütlü','Taraklı'],
  },
  {
    il: 'Samsun',
    ilceler: ['19 Mayıs','Alaçam','Asarcık','Atakum','Ayvacık','Bafra','Canik','Çarşamba','Havza','İlkadım','Kavak','Ladik','Salıpazarı','Tekkeköy','Terme','Vezirköprü','Yakakent'],
  },
  {
    il: 'Siirt',
    ilceler: ['Baykan','Eruh','Kurtalan','Pervari','Siirt','Şirvan','Tillo'],
  },
  {
    il: 'Sinop',
    ilceler: ['Ayancık','Boyabat','Dikmen','Durağan','Erfelek','Gerze','Saraydüzü','Sinop','Türkeli'],
  },
  {
    il: 'Sivas',
    ilceler: ['Akıncılar','Altınyayla','Divriği','Doğanşar','Gemerek','Gölova','Gürün','Hafik','İmranlı','Kangal','Koyulhisar','Sivas','Suşehri','Şarkışla','Ulaş','Yıldızeli','Zara'],
  },
  {
    il: 'Şanlıurfa',
    ilceler: ['Akçakale','Birecik','Bozova','Ceylanpınar','Eyyübiye','Halfeti','Haliliye','Harran','Hilvan','Karaköprü','Siverek','Suruç','Viranşehir'],
  },
  {
    il: 'Şırnak',
    ilceler: ['Beytüşşebap','Cizre','Güçlükonak','İdil','Silopi','Şırnak','Uludere'],
  },
  {
    il: 'Tekirdağ',
    ilceler: ['Çerkezköy','Çorlu','Ergene','Hayrabolu','Kapaklı','Malkara','Marmaraereğlisi','Muratlı','Saray','Süleymanpaşa','Şarköy'],
  },
  {
    il: 'Tokat',
    ilceler: ['Almus','Artova','Başçiftlik','Erbaa','Niksar','Pazar','Reşadiye','Sulusaray','Tokat','Turhal','Yeşilyurt','Zile'],
  },
  {
    il: 'Trabzon',
    ilceler: ['Akçaabat','Araklı','Arsin','Beşikdüzü','Çarşıbaşı','Çaykara','Dernekpazarı','Düzköy','Hayrat','Köprübaşı','Maçka','Of','Ortahisar','Sürmene','Şalpazarı','Tonya','Vakfıkebir','Yomra'],
  },
  {
    il: 'Tunceli',
    ilceler: ['Çemişgezek','Hozat','Mazgirt','Nazımiye','Ovacık','Pertek','Pülümür','Tunceli'],
  },
  {
    il: 'Uşak',
    ilceler: ['Banaz','Eşme','Karahallı','Sivaslı','Ulubey','Uşak'],
  },
  {
    il: 'Van',
    ilceler: ['Bahçesaray','Başkale','Çaldıran','Çatak','Edremit','Erciş','Gevaş','Gürpınar','İpekyolu','Muradiye','Özalp','Saray','Tuşba'],
  },
  {
    il: 'Yalova',
    ilceler: ['Altınova','Armutlu','Çiftlikköy','Çınarcık','Termal','Yalova'],
  },
  {
    il: 'Yozgat',
    ilceler: ['Akdağmadeni','Aydıncık','Boğazlıyan','Çandır','Çayıralan','Çekerek','Kadışehri','Saraykent','Sarıkaya','Şefaatli','Sorgun','Yenifakılı','Yerköy','Yozgat'],
  },
  {
    il: 'Zonguldak',
    ilceler: ['Alaplı','Çaycuma','Devrek','Gökçebey','Kilimli','Kozlu','Zonguldak'],
  },
];
